/* DYOCHAIN – Materialseite
   1) Sticky-Abschnittsnavigation (sections/dyo-page-index.liquid, Modus „Sticky-Buttonleiste“; ebenso die Leiste der Natursteinseiten,
      snippets/dyo-naturstein-toc.liquid):
      - bleibt beim Scrollen unmittelbar unter der angehefteten Hauptnavigation (Höhe wird gemessen, nichts ist fest verdrahtet)
      - setzt --dyo-mat-offset (Hauptnavigation + Abschnittsnavigation) für die Sprungziele (scroll-margin-top in dyo-materials.css)
      - hebt beim Scrollen den aktuellen Abschnitt hervor und hält ihn in der horizontal scrollbaren Buttonreihe sichtbar
   2) Verpackungsvideo (Variante „Materialseite“ von image-with-text): bei „Bewegung reduzieren“ nicht automatisch abspielen.
   Ohne JavaScript funktionieren die Sprunglinks weiterhin (CSS-Ersatzwerte), nur Sticky-Höhe und Hervorhebung entfallen.
   Das Skript ist wiederholt ausführbar und initialisiert sich im Theme-Editor nach Änderungen neu
   (shopify:section:load / unload / reorder). */
(function () {
  'use strict';

  if (window.DyoMaterials) {
    window.DyoMaterials.init();
    return;
  }

  var controllers = [];

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Höhe der angehefteten Hauptnavigation. Ist sie nicht angeheftet oder gerade eingeklappt
     (Einstellung „beim Hochscrollen“), ist der Abstand 0. */
  function headerOffset() {
    var header = document.querySelector('.section-header');
    if (!header) return 0;
    /* Das Theme gibt .section-header immer position: sticky; angeheftet ist die Hauptnavigation aber erst mit der Klasse
       shopify-section-header-sticky (Einstellung „immer“ sofort, „beim Hochscrollen“ nach dem Scrollen). */
    var position = window.getComputedStyle(header).position;
    if (!header.classList.contains('shopify-section-header-sticky') && position !== 'fixed') return 0;
    if (header.classList.contains('shopify-section-header-hidden')) return 0;
    return Math.round(header.getBoundingClientRect().height);
  }

  function targetOf(link) {
    var raw = link.getAttribute('href') || '';
    if (raw.charAt(0) !== '#' || raw.length < 2) return null;
    var id = raw.slice(1);
    try { id = decodeURIComponent(id); } catch (e) { /* unverändert verwenden */ }
    return document.getElementById(id);
  }

  function setupNav(nav) {
    /* Materialseite: die Section-Hülle ist angeheftet. Natursteinseiten (data-dyo-mat-self): die Leiste selbst. */
    var host = nav.hasAttribute('data-dyo-mat-self') ? nav : (nav.closest('.shopify-section') || nav.parentElement);
    var row = nav.querySelector('.dyo-mat__toc') || nav.querySelector('[data-dyo-mat-toc]');
    var items = [];
    var activeId = null;
    var queued = false;
    var top = 0;
    var observers = [];

    host.classList.add('dyo-mat-nav-host');

    function collect() {
      items = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]')).map(function (link) {
        return { link: link, target: targetOf(link) };
      }).filter(function (item) { return item.target; });
    }

    function measure() {
      top = headerOffset();
      host.style.setProperty('--dyo-mat-nav-top', top + 'px');
      document.documentElement.style.setProperty('--dyo-mat-offset', (top + nav.offsetHeight) + 'px');
    }

    function updateActive() {
      var limit = top + nav.offsetHeight + 40;
      var current = null;
      items.forEach(function (item) {
        if (item.target.getBoundingClientRect().top <= limit) current = item;
      });
      if (!current && items.length && items[0].target.getBoundingClientRect().top < window.innerHeight * 0.6) current = items[0];
      var id = current ? current.target.id : '';
      if (id === activeId) return;
      activeId = id;
      items.forEach(function (item) {
        var active = item.target.id === id;
        item.link.classList.toggle('is-active', active);
        if (active) {
          item.link.setAttribute('aria-current', 'location');
          if (row) {
            var left = item.link.offsetLeft - row.offsetLeft;
            if (left < row.scrollLeft || left + item.link.offsetWidth > row.scrollLeft + row.clientWidth) {
              row.scrollTo({ left: Math.max(0, left - 20), behavior: 'auto' });
            }
          }
        } else {
          item.link.removeAttribute('aria-current');
        }
      });
    }

    function refresh() {
      measure();
      updateActive();
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        updateActive();
      });
    }

    function onClick(event) {
      var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link || !nav.contains(link)) return;
      var target = targetOf(link);
      if (!target) return;
      event.preventDefault();
      measure();
      /* Die Zielposition ergibt sich allein aus scroll-margin-top (Hauptnavigation + Abschnittsnavigation + 24px);
         es wird nichts doppelt addiert. */
      target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + target.id);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }

    collect();
    refresh();

    nav.addEventListener('click', onClick);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);

    if ('ResizeObserver' in window) {
      var resize = new ResizeObserver(refresh);
      resize.observe(nav);
      var header = document.querySelector('.section-header');
      if (header) resize.observe(header);
      observers.push(resize);
    }
    if ('MutationObserver' in window) {
      var header2 = document.querySelector('.section-header');
      if (header2) {
        var mutation = new MutationObserver(refresh);
        mutation.observe(header2, { attributes: true, attributeFilter: ['class'] });
        observers.push(mutation);
      }
    }

    return {
      nav: nav,
      cleanup: function () {
        nav.removeEventListener('click', onClick);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', refresh);
        window.removeEventListener('load', refresh);
        observers.forEach(function (observer) { observer.disconnect(); });
        host.style.removeProperty('--dyo-mat-nav-top');
      }
    };
  }

  function setupVideos() {
    if (!prefersReducedMotion()) return;
    Array.prototype.forEach.call(document.querySelectorAll('video[data-dyo-mat-video]'), function (video) {
      video.pause();
      video.controls = true;
    });
  }

  function init() {
    /* Immer sauber neu aufbauen: bestehende Controller (auch die entfernter Navigationen im Theme-Editor) beenden */
    controllers.forEach(function (controller) { controller.cleanup(); });
    controllers = [];
    document.documentElement.style.removeProperty('--dyo-mat-offset');
    Array.prototype.forEach.call(document.querySelectorAll('[data-dyo-mat-nav]'), function (nav) {
      controllers.push(setupNav(nav));
    });
    setupVideos();
  }

  window.DyoMaterials = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (name) {
    document.addEventListener(name, function () { window.setTimeout(init, 0); });
  });
})();
